import { BootstrapHttpError } from "./bootstrapError";

function summarizeUnexpectedJsonBody(body: string): string {
  const normalized = body.replace(/\s+/g, " ").trim();
  return normalized.length === 0 ? "<empty response>" : normalized.slice(0, 120);
}

export async function readJsonResponse<T>(response: Response, endpointLabel: string): Promise<T> {
  const body = await response.text();
  try {
    return JSON.parse(body) as T;
  } catch {
    const preview = summarizeUnexpectedJsonBody(body);
    throw new BootstrapHttpError({
      message: `${endpointLabel} returned a non-JSON response (${preview}). Ensure the Forge server is running and this route is proxied correctly.`,
      status: response.status,
    });
  }
}
